module.exports = __webpack_public_path__ + "img/book-images-L.9838e4d1.png";